import { Grid, IconButton, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { FormattedMessage } from "react-intl";

export const BackButton = () => {
	const navigate = useNavigate();
	return (
		<Grid container alignItems="center" gap={2} onClick={() => navigate(-1)} sx={{ cursor: "pointer" }}>
			<IconButton>
				<ChevronLeftIcon />
			</IconButton>

			<Typography>
				<FormattedMessage id="Back" defaultMessage="Back" />
			</Typography>
		</Grid>
	);
};
